import './Radio.scss'

import { useEffect, useState } from "react"

const Radio = ({ control, options, onChange, onSelect, defaultValue = options[0].value }) => {
    const [selectedOption, setSelectedOption] = useState()

    const selectOption = (option) => {
        if (option?.value !== selectedOption?.value) {
            setSelectedOption(option)
            if (control) control.setValue(option?.value)
            if (onChange) onChange(option?.value)
            if (onSelect) onSelect(option)
        }
    }

    const updateFromValue = (value) => {
        if (value !== selectedOption?.value) {
            const valueOption = options.find((option) => option.value === value)
            setSelectedOption(valueOption)
            if (onChange) onChange(valueOption?.value)
            if (onSelect) onSelect(valueOption)
        }
    }

    useEffect(() => {
        if (control) {
            updateFromValue(control.value)
        }
    }, [control?.value])
    
    useEffect(() => {
        updateFromValue(control ? control.value : defaultValue)
    }, [])

    return (
        <ul className="radio d-flex">
            {options.map((option) => (
                <li className="option flex-center-y" onClick={() => selectOption(option)} key={option.value}>
                    <div className={`dot ${option.value === selectedOption?.value ? 'selected' : ''} mr-2`}></div>
                    <span className="label">{option.label}</span>
                </li>
            ))}
        </ul>
    )
}

export default Radio